import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'
import { useUpdateMaterialMutation } from '../../features/fullApi';

export default function EditDialog({openEdit, setOpenEdit, handleUpdateMaterial, item}) {

    const user = JSON.parse(localStorage.getItem('user'))
    const [updateMaterial] = useUpdateMaterialMutation()

    const onSubmit = async(values, actions) => {
          updateMaterial({_id: item._id, materialName: values.materialName }, { 
          headers: {
              'Token': `Bearer ${user?.accessToken}`
          }
          }, {id: item._id})
          .then(res => {
            console.log("res is")
          })
          .catch((e) => {
          console.log("e is", e)
          })
      }
      
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          materialName: item?.materialName,
        },
        onSubmit,
      });

    return (
        <form onSubmit={handleSubmit} >
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenEdit(false)} open={openEdit}>
                <DialogTitle id='dialog-title'>
                    Edit Material
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{color: "red"}}>You are editing {item?.materialName}</DialogContentText>
                    <TextField
                        id="materialName"
                        type="text"
                        margin="dense"
                        value={values.materialName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.materialName ? "" : "Material"}
                    />
                    {errors.materialName && touched.materialName && (
                        <p className="error">{errors.materialName}</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpenEdit(false)}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleUpdateMaterial({id: item, materialName: values.materialName})}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}